export const COUPON_CLAIM_SUCCESS_EVENT = 'gwb-coupon-claim-success'

export const emitCouponClaimSuccess = (detail = {}) => {
  window.dispatchEvent(new CustomEvent(COUPON_CLAIM_SUCCESS_EVENT, { detail }))
}
